<template>
  <div id="app" :class="{ 'dark-theme': isDarkTheme }">
    <router-view />
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useThemeStore } from './stores/theme'

const themeStore = useThemeStore()
const isDarkTheme = computed(() => themeStore.isDarkTheme)
</script>

<style>
@import './assets/styles.css';
</style>
